const locale = {
  title: "Title",
};
export default locale;
